// export const generateBreadcrumbs = (pathName: string) => {
//     let breadcrumbs: { name: string; link: string }[] = [];

//     // Logic to generate breadcrumbs based on pathName
//     if (pathName === '/') {
//       breadcrumbs = [{ name: 'Home', link: '/' }];
//     } else if (pathName.startsWith('/admin')) {
//       breadcrumbs = [
//         { name: 'Home', link: '/' },
//         { name: 'Admin', link: '/admin' },
//       ];
//     } else {
//       // Default breadcrumbs for other routes
//       breadcrumbs = [{ name: 'Home', link: '/' }];
//     }

//     return breadcrumbs;
//   };

export const generateBreadcrumbs = (pathName: string) => {
  const breadcrumbs: { name: string; link: string }[] = [];

  if (pathName === '/' || pathName === '') {
    breadcrumbs.push({
      name: 'Home',
      link: '/',
    });
  }

  const segments = pathName.split('/').filter(segment => segment !== '');

  let currentPath = '';
  for (let i = 0; i < segments.length; i++) {
    let displayName = segments[i];

    if (segments[i - 1] === 'campaigns' && segments[i] !== 'myTeam' && segments[i] !== 'participants') {
      displayName = 'My Progress';
    }

    // Check if the current segment is a number and the previous segment is 'teams'
    if (!isNaN(Number(segments[i])) && segments[i - 1] === 'teams') {
      displayName = 'Team Details';
    }

    if (!isNaN(Number(segments[i])) && segments[i - 1] === 'participants') {
      displayName = 'Participants';
    }

    if (segments[i] === 'myTeam' || (!isNaN(Number(segments[i])) && segments[i - 1] === 'myTeam')) {
      displayName = 'My Team';
    }

    if (segments[i] === 'edit' && segments[i - 1] === 'profile') {
      displayName = 'Edit Profile';
    }

    if (segments[i] === 'join-team') {
      displayName = 'Join Team';
    }

    if (!isNaN(Number(segments[i])) && segments[i - 1] === 'coach') {
      displayName = 'Coach Profile';
    }

    // Check if the current segment is 'user'
    if (segments[i] === 'user') {
      displayName = 'Participant Profile';
    }

    if (segments[i] === 'create-team') {
      displayName = 'Get Started';
    }

    if (segments[i] === 'coachEnrollment') {
      displayName = 'Coach Enrollment';
    }

    if (segments[i] === 'privacy-security') {
      displayName = 'Privacy Policy';
    }

    if (segments[i] === 'terms-and-conditions') {
      displayName = 'Terms & Conditions';
    }

    currentPath += `/${segments[i]}`;

    if (!breadcrumbs.find(i => i.name === displayName) && displayName !== 'campaigns' && displayName !== 'Join Team') {
      breadcrumbs.push({
        name: displayName.charAt(0).toUpperCase() + displayName.slice(1),
        link: currentPath,
      });
    }
  }

  if (breadcrumbs.length > 0) {
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
    const index = lastBreadcrumb.link.indexOf('?');
    if (index !== -1) {
      lastBreadcrumb.link = lastBreadcrumb.link.substring(0, index);
    }
  }

  return breadcrumbs;
};
